export default "__VITE_ASSET__DEuF80cG__"